import React from 'react';
import { Pane, PaneProps, IconButton, Tooltip } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import { NavLinkButton } from './NavLinkButton';
import { LinkButtonType } from './types';

interface LinkButtonsProps {
  buttons: Array<LinkButtonType>
  /** префикс, который вставляется перед `to`, формируя строку `${pathPrefix}${to}` */
  pathPrefix?: string,
}

export function LinkButtonsWrap({ children, ...paneProps }: PaneProps) {
  return (
    <Pane
      display="grid"
      gap=".2rem"
      gridAutoColumns="max-content"
      gridAutoFlow="column"
      justifyContent="end"
      {...paneProps}
    >
      {children}
    </Pane>
  );
}

/**
 * Строчка кнопок-навигаций.
 *
 * Можно передать атрибуты для Pane для дополнительной стилизации
 */
export const NavLinkButtons = React.memo(({ buttons = [], pathPrefix = '', ...paneProps }: LinkButtonsProps & PaneProps) => {
  if (buttons?.length === 0) return null;
  return (
    <LinkButtonsWrap {...paneProps}>
      {
        buttons.map(({ to, name, icon, isInvisible }) => !isInvisible && (
          <NavLinkButton
            key={`${pathPrefix}${to}`}
            to={`${pathPrefix}${to}`}
            iconBefore={icon}
          >
            {name}
          </NavLinkButton>

        ))
      }
    </LinkButtonsWrap>
  );
});
NavLinkButtons.displayName = 'NavLinkButtons';

/**
 * Строчка иконок-навигаций.
 *
 * Можно передать атрибуты для Pane для дополнительной стилизации
 */
export const LinkIconsWithTooltip = React.memo(({ buttons = [], pathPrefix = '', ...paneProps }: LinkButtonsProps & PaneProps) => {
  if (buttons?.length === 0) return null;
  return (
    <LinkButtonsWrap {...paneProps}>
      {
        buttons.map(({ to, name, icon, isInvisible }) => !isInvisible && (
          <Tooltip key={to} content={name}>
            <IconButton
              key={`${pathPrefix}${to}`}
              is={Link}
              to={`${pathPrefix}${to}`}
              appearance="minimal"
              icon={icon}
            />
          </Tooltip>
        ))
      }
    </LinkButtonsWrap>
  );
});
LinkIconsWithTooltip.displayName = 'LinkIconsWithTooltip';
